package com.rainbowclubs.rainbow.domain.repositories

import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.data.requests.UpdateClubRequest

interface ClubRepository {
    suspend fun getClubById(clubId: String): Result<Club>
    suspend fun getClubImage(imageUrl: String): Result<ByteArray>
    suspend fun updateClub(
        clubId: String,
        request: UpdateClubRequest,
        image: ClubImageUpload? = null,
    ): Result<Club>
}

data class ClubImageUpload(
    val bytes: ByteArray,
    val fileName: String,
    val contentType: String,
)
